var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("content"),_c('ui-limit-pagination',{attrs:{"need-add-btns":_vm.needAddBtns,"pagination":_vm.pagination},on:{"input":_vm.handlePaginate}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }